// @ts-nocheck

import React, { forwardRef, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { basketStakeChange, basketItemStakeChange } from '../../actions/basket';
import useBindActionsCreator from '../../hooks/useBindActionsCreator';
import useMergeProps from '../../hooks/useMergeProps';
import NumericKeyboard, { type NumericKeyboardProps } from '../common/NumericKeyboard';

import selectBasketKeyboardProps from './BasketKeyboard.selector';

type BasketKeyboardContainerProps = {
  itemId?: number;
  ref?: unknown;
  className?: string;
};

const BasketKeyboardContainer = forwardRef<BasketKeyboardContainerProps, unknown>(function BasketKeyboardContainer(
  { itemId: itemIdFromProps, ...ownProps }: BasketKeyboardContainerProps,
  ref,
) {
  const selectorProps = useMemo(() => ({ itemId: itemIdFromProps }), [itemIdFromProps]);
  const selectedProps = useSelector((state) => selectBasketKeyboardProps(state, selectorProps));
  const { isVisible, itemId } = selectedProps;

  const { itemStakeChange, stakeChange } = useBindActionsCreator({
    itemStakeChange: basketItemStakeChange,
    stakeChange: basketStakeChange,
  });

  const actionsProps = useMemo(
    () => ({
      onInputChange: (stake) => {
        if (itemId) {
          itemStakeChange({ oddId: itemId, stake });
        } else {
          stakeChange({ stake });
        }
      },
    }),
    [itemId, itemStakeChange, stakeChange],
  );

  const otherProps = useMemo(() => ({ ref }), [ref]);

  const enhancedProps: NumericKeyboardProps = useMergeProps({ ownProps, selectedProps, actionsProps, otherProps });

  return isVisible ? <NumericKeyboard {...enhancedProps} /> : null;
});

export default React.memo<BasketKeyboardContainerProps>(BasketKeyboardContainer);
